import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


const TagLabel = ({ name, theme, maxWidth, withoutBorder, extraClassName }) => {
  const tagThemes = {
    grey: 'grey',
    brown: 'brown',
  };
  const style = {
    maxWidth: maxWidth || 'unset',
  };
  const tagTheme = tagThemes[theme];
  return (
    <div
      style={style}
      className={classNames(withoutBorder ? styles.withoutBorder : styles[tagTheme], extraClassName)}>
      {name}
    </div>
  );
};

TagLabel.propTypes = {
  name: PropTypes.string.isRequired,
  extraClassName: PropTypes.string,
  theme: PropTypes.string,
  maxWidth: PropTypes.number,
  withoutBorder: PropTypes.bool,
};

TagLabel.defaultProps = {
  theme: 'brown',
  maxWidth: 0,
  withoutBorder: false,
};

export default TagLabel;
